import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useState } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export function IPFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [value, setValue] = useState((item.value as string) || '');
  const [hasError, setHasError] = useState(false);

  function isValidIP(ip: string) {
    const trimmedIp = ip.trim();
    const ipv4Pattern =
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    const ipv6Pattern =
      /^(([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4}|:)|(([0-9a-fA-F]{1,4}:){1,6}|:):(([0-9a-fA-F]{1,4}:){1,6}|:)|::|(([0-9a-fA-F]{1,4}:){1,5}|:):(([0-9a-fA-F]{1,4}:){1,5}|:):|(([0-9a-fA-F]{1,4}:){1,4}|:):(([0-9a-fA-F]{1,4}:){1,4}|:):|(([0-9a-fA-F]{1,4}:){1,3}|:):(([0-9a-fA-F]{1,4}:){1,3}|:):|(([0-9a-fA-F]{1,4}:){1,2}|:):(([0-9a-fA-F]{1,4}:){1,2}|:):|([0-9a-fA-F]{1,4}|:):([0-9a-fA-F]{1,4}|:):)$/;
    return ipv4Pattern.test(trimmedIp) || ipv6Pattern.test(trimmedIp);
  }

  const handleFilterChange = (newValue: string) => {
    if (!isValidIP(newValue)) {
      setHasError(true);
      return;
    } else {
      setHasError(false);
      applyValue({ ...item, value: newValue });
    }
  };

  return (
    <Box
      sx={{
        width: 300,
        position: 'relative',
        top: -19.5,
      }}
    >
      <TextField
        fullWidth
        error={hasError}
        helperText={hasError ? 'Please enter a full IP address' : ' '}
        label="Full IP Address"
        variant="standard"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          handleFilterChange(e.target.value);
        }}
      />
    </Box>
  );
}
